import { APP_STATUS } from '@/constants/appStatus';

export const getRedirectPathByAppStatus = async (appStatus: string) => {
  switch (appStatus) {
    case APP_STATUS.accountCreated:
      return '/register?q=username';
    case APP_STATUS.userInformationRegistered:
      return '/value';
    case APP_STATUS.personalValueQuestionAnswered:
      return '/top';
    default:
      return '/register';
  }
};
